import React, { useEffect, useMemo, useState } from 'react';
import Modal from 'react-modal';

import useScrollPercentage from '../hooks/useScrollPercentage';
import { useScrollDisable } from '../hooks/useScrollDisable';
import { DocumentsModalFooter } from './DocumentsModalFooter';
import { DocumentsCarousel } from './DocumentsCarousel';
import { DocumentsModalHeader } from './DocumentsModalHeader';
import { useDocumentTimeout } from '../hooks/useDocumentTimeout';
import { useScrollInfoModal } from '../hooks/useScrollInfoModal';

import 'react-virtualized/styles.css';

const DocumentsModal = ({
    documentsList,
    showDocumentModal,
    onDocumentRead,
    onDocumentAccepted,
    onSaveDocumentAcceptance,
    handleClose,
    aDocumentWasAccepted,
    aDocumentWasNotAccepted
}) => {
    const [currentDocumentIndex, setCurrentDocumentIndex] = useState(0);
    const [isSavingDocumentAcceptance, setIsSavingDocumentAcceptance] = useState(false);
    const currentDocument = useMemo(() => documentsList?.[currentDocumentIndex], [documentsList, currentDocumentIndex]);
    const areAlldocumentsAccepted = useMemo(
        () => documentsList.every(document => document.isAccepted),
        [documentsList]
    );
    const isDocumentAccepted = currentDocument && currentDocument.isAccepted;
    const isDocumentRead = currentDocument && currentDocument.isRead;

    useEffect(() => {
        setCurrentDocumentIndex(0);
    }, [showDocumentModal]);

    useEffect(() => {
        if (aDocumentWasAccepted && documentsList.length > 0) {
            const nextDocumentIndex = currentDocumentIndex + 1;

            if (nextDocumentIndex === documentsList.length) {
                handleClose(scrollPercentage);
            } else {
                setCurrentDocumentIndex(nextDocumentIndex);
            }
            onDocumentAccepted(documentsList[currentDocumentIndex]);
            setIsSavingDocumentAcceptance(false);
        }

        if (aDocumentWasNotAccepted) {
            setIsSavingDocumentAcceptance(false);
        }
    }, [aDocumentWasAccepted, aDocumentWasNotAccepted])

    useScrollDisable({ condition: showDocumentModal });
    const [pdfContainerRef, scrollPercentage] = useScrollPercentage();

    const { renderScrollInfoModal, openScrollInfoModal, scrollInfoModalShowed } = useScrollInfoModal({
        onClickCancelButton: e => handleClose(e, scrollPercentage),
    });

    const { resetTimeoutFunction, stopTimeoutFunction } = useDocumentTimeout(
        {
            startCondition: !isDocumentRead && !isDocumentAccepted && showDocumentModal && !scrollInfoModalShowed,
            callback: () => {
                openScrollInfoModal('vista timeout');
            },
            timeLapse: 15000,
        },
        [showDocumentModal]
    );

    const recordTagPrecontractualModal = (tagEvent, customData = {}) => {
    };

    const handleScroll = ({ documentIndex, isAtBottom }) => {
        const document = documentsList[documentIndex];
        if (!isAtBottom) {
            resetTimeoutFunction();
        } else if (!document.isRead) {
            onDocumentRead(document);
            stopTimeoutFunction();
        }
    };

        const handleConfirm = e => {
        e.preventDefault();
        handleClose(e, scrollPercentage);
    };

    const handleOnContinue = e => {
        e.preventDefault();
        setCurrentDocumentIndex(prevState => prevState + 1);
    };

    const handleAcceptanceAndContinue = e => {
        e.preventDefault();
        setIsSavingDocumentAcceptance(true);
        onSaveDocumentAcceptance(currentDocument);
    };

    const handleClickContinueDisabled = e => {
        e.preventDefault();
        stopTimeoutFunction();
        openScrollInfoModal('vista click');
    };

    const handleClickCloseButton = e => {
        e.preventDefault();
        handleClose(e, scrollPercentage);
    };

    const handleClickCancelButton = e => {
        e.preventDefault();
        openScrollInfoModal('vista click');
        stopTimeoutFunction();
    };

    return (
        <Modal
            isOpen={showDocumentModal}
            style={{
            overlay: {
                zIndex: 2101,
            },
        }}>
            <div>
                <div className='documents__modal__box-inside'>
                    <div className="documents__modal__container">
                        <DocumentsModalHeader
                            documentsList={documentsList}
                            currentDocumentIndex={currentDocumentIndex}
                        />
                        <DocumentsCarousel
                            documentsList={documentsList}
                            currentDocumentIndex={currentDocumentIndex}
                            pdfContainerRef={pdfContainerRef}
                            onScroll={handleScroll}
                            recordTagPrecontractualModal={recordTagPrecontractualModal}
                        />
                        <DocumentsModalFooter
                            areAlldocumentsAccepted={areAlldocumentsAccepted}
                            isCurrentDocumentAcepted={isDocumentAccepted}
                            isCurrentDocumentRead={isDocumentRead}
                            isSavingDocumentAcceptance={isSavingDocumentAcceptance}
                            onClose={handleClickCloseButton}
                            onCancel={handleClickCancelButton}
                            onConfirm={handleConfirm}
                            onContinue={handleOnContinue}
                            onAcceptAndContinue={handleAcceptanceAndContinue}
                            onContinueDisabled={handleClickContinueDisabled}
                        />
                    </div>
                </div>
                {renderScrollInfoModal()}
            </div>
        </Modal>
    );
};
export default DocumentsModal;